import {
  ArrowLeftOutlined,
  FileProtectOutlined,
  PrinterOutlined,
} from "@ant-design/icons";
import { Alert, Button, Card, Collapse, Dropdown, Skeleton } from "antd";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  fetchAviationForm,
  updateCustomerCode,
} from "../../../store/applicationsSearch/applicationsSearchThunks";
import ApplicationHeaderBar from "../shared/ApplicationHeaderBar";
import AircraftInformationDetails from "./AircraftInformationDetails";
import AirportInformationDetails from "./AirportInformationDetails";
import ApplicantsDetails from "./ApplicantsDetails";
import CollapseSectionHeader from "./CollapseSectionHeader";
import OperationsDetails from "./OperationsDetails";
import PilotInformationDetails from "./PilotInformationDetails";
import { downloadFile } from "../../../shared/downloadFile";

const ApplicationDetailView = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { applicationId } = useParams();

  const data = useSelector(
    (state) => state.applicationsSearch.viewApplication.data
  );
  const isLoading = useSelector(
    (state) => state.applicationsSearch.viewApplication.isLoading
  );

  useEffect(() => {
    if (applicationId) {
      dispatch(fetchAviationForm({ id: applicationId }));
    }
  }, [dispatch, applicationId]);

  const headerActions = [
    <Button size="small" onClick={() => navigate(-1)}>
      <ArrowLeftOutlined /> Go Back
    </Button>,
    <Button
      key="quote"
      size="small"
      type="primary"
      icon={<FileProtectOutlined />}
      onClick={() => {
        navigate(`/applications/quote/${applicationId}`);
      }}
    >
      Quote
    </Button>,
    <Dropdown
      menu={{
        items: [
          {
            label: "Latest",
            key: "latest",
          },
          {
            label: "Signed",
            key: "signed",
          },
        ],
        onClick: ({ key }) => {
          if (key === "latest") {
            dispatch(
              downloadFile({
                url: `/private_aviation/forms/${applicationId}/serve_pdf`,
              })
            );
          } else if (key === "signed") {
            dispatch(
              downloadFile({
                url: `/private_aviation/forms/${applicationId}/serve_submitted_pdf`,
              })
            );
          }
        },
      }}
      trigger={["click"]}
    >
      <Button
        key="download"
        size="small"
        type="dashed"
        onClick={(e) => e.preventDefault()}
      >
        <PrinterOutlined /> Print application
      </Button>
    </Dropdown>,
  ];

  const items = [
    {
      key: "applicants",
      label: (
        <CollapseSectionHeader
          name="Applicants Information"
          route="applicants"
        />
      ),
      children: <ApplicantsDetails data={data} />,
    },
    {
      key: "aircraft-core",
      label: (
        <CollapseSectionHeader name="Aircraft Information" route="aircraft" />
      ),
      children: <AircraftInformationDetails data={data} />,
    },
    {
      key: "ops-trips",
      label: (
        <CollapseSectionHeader name="Operations & Trips" route="operations" />
      ),
      children: <OperationsDetails data={data} />,
    },
    {
      key: "airport",
      label: (
        <CollapseSectionHeader name="Airport Information" route="airport" />
      ),
      children: <AirportInformationDetails data={data} />,
    },
    {
      key: "pilots",
      label: <CollapseSectionHeader name="Pilot Information" route="pilot" />,
      children: <PilotInformationDetails data={data} />,
    },
  ];

  return !isLoading && !data ? (
    <Alert
      type="error"
      showIcon
      message="Error: Something went wrong while loading this application."
      className="default-margin"
    />
  ) : (
    <Card className="body-card-content-no-min-height">
      <Skeleton active loading={isLoading}>
        <ApplicationHeaderBar
          data={data}
          actions={headerActions}
          onCustomerCodeSave={(value) => {
            dispatch(
              updateCustomerCode({ id: applicationId, customerCode: value })
            );
          }}
          extended
        />
        <Collapse defaultActiveKey={["aircraft-core"]} items={items} />
      </Skeleton>
    </Card>
  );
};

export default ApplicationDetailView;
